import { wccModules } from "enums/wccModules";
import { inject } from "inversify";
import { Subscribable } from "knockout";
import { EffectsContainer } from "mixins/withEffects";
import WCCSliderItemVM from "../base/base";
import WCCSliderDynamicItem from "./dynamic.model";
import './dynamic.html';

export default class WCCSliderDynamicItemVM<T> extends WCCSliderItemVM<T> {
    width: Subscribable<number>

    constructor(
        @inject(wccModules.componentConfig) model: WCCSliderDynamicItem<T>,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        super(model, info, effects);

        this.width = ko.pureComputed(() => model.getWidth());

        ko.applyBindingsToNode(info.element, {
            'css': {
                'wcc-slider__item--dynamic': true
            },
            'style': {
                'width': this.width.toPx(true)
            }
        });
    }
}